import styled from "styled-components";

export const LicensePlateFormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 12px;
`;

export const LicensePlateFormBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
`;

export const LicensePlateFormTitleWrapper = styled.div`
  padding-block: 8px;
  text-align: center;
`;

export const LicensePlateFormInputWrapper = styled.div`
  height: 72px;
  width: 730px;
  @media (width<768px) {
    width: 90vw;
  }
`;
export const TitleWrapper = styled.div`
  margin-bottom: 10px;
  
`;

export const LicensePlateFormSelectWrapper = styled.div`
  height: 72px;
  width: 730px;
  @media (width<768px) {
    width: 90vw;
  }
`;

export const LicensePlateFormButtonWrapper = styled.div`
  height: 75px;
  width: 730px;
  margin-top: 12px;
  @media (width<768px) {
    width: 90vw;
  }
`;
